exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner[data-v-198c1340] {\n  position: fixed;\n  top: 50px;\n  left: 50%;\n  margin-left: -587.5px;\n  z-index: 99;\n}\n@media only screen and (max-width: 1215px) {\n.inner[data-v-198c1340] {\n    left: -20px;\n    margin-left: auto;\n}\n}", ""]);

// exports
